/// <reference types="./toggler.d.mts" />
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $e from "../../../lustre/lustre/event.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $html from "../../../sketch_lustre/sketch/lustre/element/html.mjs";
import * as $colors from "../../ds/colors.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

class Active extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class OnClick extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Disabled extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Props extends $CustomType {
  constructor(active, on_change, disabled) {
    super();
    this.active = active;
    this.on_change = on_change;
    this.disabled = disabled;
  }
}

export function active(a) {
  return new Active(a);
}

export function on_change(h) {
  return new OnClick(h);
}

export function disabled(d) {
  return new Disabled(d);
}

function to_props(attributes) {
  let empty = new Props(false, new $option.None(), new $option.None());
  return $list.fold(
    attributes,
    empty,
    (props, attribute) => {
      if (attribute instanceof Active) {
        let active$1 = attribute[0];
        let _record = props;
        return new Props(active$1, _record.on_change, _record.disabled);
      } else if (attribute instanceof OnClick) {
        let h = attribute[0];
        let _record = props;
        return new Props(_record.active, new $option.Some(h), _record.disabled);
      } else {
        let d = attribute[0];
        let _record = props;
        return new Props(_record.active, _record.on_change, new $option.Some(d));
      }
    },
  );
}

function state(props) {
  let _pipe = $css.class$(
    toList([
      $css.width(px(16)),
      $css.height(px(16)),
      $css.border_radius(px(20)),
      $css.border_width(px(1)),
      $css.border_style("solid"),
      $css.border_color(
        (() => {
          let $ = props.disabled;
          let $1 = props.active;
          if ($ instanceof $option.Some) {
            let $2 = $[0];
            if ($2) {
              return $colors.light.grey_600;
            } else if ($1) {
              return $colors.light.success_600;
            } else {
              return $colors.light.blue_600;
            }
          } else if ($1) {
            return $colors.light.success_600;
          } else {
            return $colors.light.blue_600;
          }
        })(),
      ),
      $css.background($colors.light.text_white),
      $css.position("absolute"),
      $css.top(px(1)),
      $css.left(
        (() => {
          let $ = props.disabled;
          let $1 = props.active;
          if ($ instanceof $option.Some) {
            let $2 = $[0];
            if ($2) {
              return px(1);
            } else if ($1) {
              return px(17);
            } else {
              return px(1);
            }
          } else if ($1) {
            return px(17);
          } else {
            return px(1);
          }
        })(),
      ),
      $css.transition("left .3s, border-color .3s"),
    ]),
  );
  return $html.div(_pipe, toList([]), toList([]));
}

function content(props) {
  let _pipe = $css.class$(
    toList([
      $css.cursor(
        (() => {
          let $ = props.disabled;
          if ($ instanceof $option.Some) {
            let $1 = $[0];
            if ($1) {
              return "not-allowed";
            } else {
              return "pointer";
            }
          } else {
            return "pointer";
          }
        })(),
      ),
      $css.width(px(36)),
      $css.height(px(20)),
      $css.padding(px(2)),
      $css.border_width(px(1)),
      $css.border_style("solid"),
      $css.border_color(
        (() => {
          let $ = props.disabled;
          let $1 = props.active;
          if ($ instanceof $option.Some) {
            let $2 = $[0];
            if ($2) {
              return $colors.light.grey_200;
            } else if ($1) {
              return $colors.light.success_200;
            } else {
              return $colors.light.blue_200;
            }
          } else if ($1) {
            return $colors.light.success_200;
          } else {
            return $colors.light.blue_200;
          }
        })(),
      ),
      $css.background(
        (() => {
          let $ = props.disabled;
          let $1 = props.active;
          if ($ instanceof $option.Some) {
            let $2 = $[0];
            if ($2) {
              return $colors.light.grey_400;
            } else if ($1) {
              return $colors.light.success_400;
            } else {
              return $colors.light.blue_400;
            }
          } else if ($1) {
            return $colors.light.success_400;
          } else {
            return $colors.light.blue_400;
          }
        })(),
      ),
      $css.border_radius(px(12)),
      $css.position("relative"),
      $css.transition("background .3s, border-color .3s"),
    ]),
  );
  return $html.div(_pipe, toList([]), toList([state(props)]));
}

export function toggler(attributes) {
  let props = to_props(attributes);
  return $html.label_(
    toList([]),
    toList([
      content(props),
      $html.input(
        $css.class$(toList([$css.display("none")])),
        toList([
          $a.type_("checkbox"),
          $a.checked(props.active),
          (() => {
            let $ = props.disabled;
            if ($ instanceof $option.Some) {
              let d = $[0];
              return $a.disabled(d);
            } else {
              return $a.none();
            }
          })(),
          (() => {
            let $ = props.on_change;
            if ($ instanceof $option.Some) {
              let h = $[0];
              return $e.on_check(h);
            } else {
              return $a.none();
            }
          })(),
        ]),
      ),
    ]),
  );
}
